import React, { useState } from 'react';
import './Testimonials.css';
import allUser from '../../data/img/allUsers.png';
import video from '../../data/videos/video1.mp4';
import t1 from '../../data/img/tt2.png';
import t2 from '../../data/img/tt11.png';
import playBtn from '../../data/img/play-btn.png';
import side_show_effect from '../../pages/side_show_effect';

const Testimonials = () => {
    const [play, setPlay] = useState(false);
    const videoController = e =>{
        const video  = document.getElementById('video-player')
        setPlay(true)
        video.play()
    }
    side_show_effect('.testimonial-container', '.testimonial-left', '.testimonial-right')
    return (
        <section id="testimonial">
            <div className="container">
                <div className="testimonial-container">
                    <div className="testimonial-left">
                        <h1>TESTIMONIALS</h1>
                        <p>BVarb.com is an organization and business platform that uses the art of the Arbitrage industry with the opportunity to make money through Arbitrage, using its executive technology levers such as big data, algorithms and artificial intelligence and Arbitrage in In the case of Altcoins and economic</p>
                        <div>
                            <div className="all-video-container fist-video">
                                <video id='video-player' width="400" controls={play}  poster={t1}>
                                    <source src={video} type="video/mp4"/>
                                </video>
                                {
                                    !play && <button className="play-btn" onClick={videoController}>
                                    <img src={playBtn} alt="" />
                                    </button>
                                }
                            </div>
                            <div className="all-video-container fist-video">
                                <video id='video-player' width="400" controls={play}  poster={t2}>
                                    <source src={video} type="video/mp4"/>
                                </video>
                                {
                                    !play && <button className="play-btn" onClick={videoController}>
                                    <img src={playBtn} alt="" />
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='testimonial-right'>
                        <img src={allUser} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
};
// 
export default Testimonials;